const DEFAULT_CLOSE_BUTTON_POSITION = { xl: 0, lg: 0, md: 0 };
const DEFAULT_TRANSITION_TIMEOUT = { enter: 0, exit: 0 };

const getDefaultPadding = (hasTitle) => {
  const prefix = hasTitle ? '16px' : '40px';

  return {
    xl: `${prefix} 40px 30px`,
    lg: `${prefix} 28px 16px`,
    md: `${prefix} 16px 20px`,
  };
};

export const getModalDimensions = (modalProps, theme) => {
  const defaultTop = {
    xl: theme.spacing(1),
    lg: theme.spacing(1),
    md: theme.spacing(1),
  };

  return {
    padding:
      modalProps?.paddingContent || getDefaultPadding(!!modalProps?.title),
    right: modalProps?.closeButtonRight || DEFAULT_CLOSE_BUTTON_POSITION,
    top: modalProps?.closeButtonTop || defaultTop,
    transitionTimeout:
      modalProps?.transitionTimeout || DEFAULT_TRANSITION_TIMEOUT,
  };
};
